export const RANGE_SIGN = '-';
